<div class="no-results-container clearfix" role="status">
  <div class="flex-column-container">
    <fa-icon class="no-results-ico" [icon]="icon"></fa-icon>
    <h2 i18n="@@noResultsAvailableTitle">No Results Available</h2>
    <span i18n="@@noResultsCouldntFind1"
      >We couldn’t find any results based on your search parameters. Please refine your search
      criteria and try again.</span
    >
    <span class="number_text">
      <span i18n="@@noResultsCouldntFind2"
        >If you continue to have any issues, please contact your offline travel team on
      </span>
      {{ number }}
    </span>
  </div>
</div>
